import { useCallback, useState, ReactNode } from "react"
import { useSetRefCallbacks, RefCallbacks } from "../App/useRefCallbacks"
import { classNames } from "../Components"
import { CloseButton } from "../Components/CloseButton"
import { Icon, IconType } from "../Components/Icon"

export type TabBarRender = () => ReactNode;
type SetTabSelectedCallback = (selected?: string) => void;

export interface TabBarTabProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  action?: any;
  active?: boolean;
  hide?: boolean;
  icon?: IconType;
  name: string;
  render: TabBarRender;
  selected?: boolean;
  setTabSelected?: SetTabSelectedCallback;
  title: string;
}

export interface TabBarCallbacks {
  setSelected: (value?: string) => void;
}

interface TabBarProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  closeAction?: any;
  defaultSelection?: string;
  callbacks?: RefCallbacks<TabBarCallbacks>;
  selectedCallback?: (value?: string) => void;
  tabs: TabBarTabProps[];
}

export function TabBar({ closeAction, defaultSelection, callbacks, selectedCallback, tabs }: TabBarProps) {
  const [selected, setSelected] = useState<string | undefined>(defaultSelection);
  const setTabSelected = useCallback((value?: string) => {
    if (selectedCallback) {
      selectedCallback(value);
    }
    setSelected(value);
  }, [selectedCallback]);

  useSetRefCallbacks(() => {
    return { setSelected: (value?: string) => {
      setTabSelected(value);
    } };
  }, callbacks);

  return (
    <div className="TabBar">
      <div className="TabBar-tabs">
        {closeAction && <CloseButton onClick={closeAction} />}
        {tabs.map((tab) => {
          if (tab.hide != true) {
            return <TabBarTab key={`tab-${tab.name}`} {...tab} setTabSelected={setTabSelected} selected={selected == tab.name} />;
          }
          return;
        })}
      </div>
      <div className={"TabBar-content" + (selected && " TabBar-content-" + selected)}>
        {tabs.find((tab) => tab.name == selected)?.render()}
      </div>
    </div>
  );
}

export function TabBarTab({ action, active, hide: _hide, icon, name, render: _render, setTabSelected, selected, title }: TabBarTabProps) {
  const click = useCallback(() => {
    if (action) {
      action(name);
    } else if (setTabSelected) {
      setTabSelected(name);
    }
  }, [action, setTabSelected]);
  return (
    <div className={classNames(["TabBar-tab", selected && "selected", active != false && "active"])} onClick={click}>
      {icon && <Icon icon={icon} />}
      {title}
    </div>
  );
}
